import type { RouteObject } from "react-router-dom";
import { lazy } from "react";

const Home = lazy(() => import("@/pages/home/page"));
const Products = lazy(() => import("@/pages/products/page"));
const About = lazy(() => import("@/pages/about/page"));
const Contact = lazy(() => import("@/pages/contact/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products/:slug?",
    element: <Products />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;